<template>
  <div class="TutorMedium">

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('tutor_id')" v-bind:class="{ 'active': tutor_id }">Tutor ID</btn>
        <btn class="m-btn--column" @click.native="switchV('channel_id')" v-bind:class="{ 'active': channel_id }">媒体名</btn>
        <btn class="m-btn--column" @click.native="switchV('registration_date')" v-bind:class="{ 'active': registration_date }">登録日</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div class="mediumForm">

      <div class="mediumPost is-print-none">
        <multiselect v-model="watch.channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder="媒体名"></multiselect>
        <input class="mediumForm-input" v-model="tutor_channel.registration_date" type="text" placeholder="登録日">
        <i @click="postTutor_channel" class="fa fa-plus" style="font-size: 20px; padding: 8px; cursor: pointer"></i>
      </div>

    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="searchQuery.id" type="text"></td-c></template>
          <template v-if="tutor_id"><td-c><input v-model="searchQuery.tutor_id" type="text"></td-c></template>
          <template v-if="channel_id">
            <td-c class="select">
              <multiselect v-model="watchSearch.channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="registration_date"><td-c><input v-model="searchQuery.registration_date" type="text"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="searchQuery.created_at" type="text"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="notSearchQuery.id" type="text"></td-c></template>
          <template v-if="tutor_id"><td-c><input v-model="notSearchQuery.tutor_id" type="text"></td-c></template>
          <template v-if="channel_id">
            <td-c class="select">
              <multiselect v-model="watchSearch.not_channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="registration_date"><td-c><input v-model="notSearchQuery.registration_date" type="text"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="notSearchQuery.created_at" type="text"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="tutor_id"><th-c @click.native='sort("tutor_id")'>tutor_id</th-c></template>
          <template v-if="channel_id"><th-c @click.native='sort("channel_id")'>媒体名</th-c></template>
          <template v-if="registration_date"><th-c @click.native='sort("registration_date")'>登録日</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in notFilteredTutor_channels" :key="list.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelTutor_channel(list)" class="del" style="position: relative">戻る</td-c>
            <td-c @click.native="patchTutor_channel(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="tutor_id"><td-c><input type="text" v-model="list.tutor_id"></td-c></template>
            <td-c class="select">
              <multiselect v-model="watchPatch.channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
            </td-c>
            <template v-if="registration_date"><td-c><input type="text" v-model="list.registration_date"></td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteTutor_channel(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editTutor_channel(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="tutor_id"><td-c>{{list.tutor_id}}</td-c></template>
            <template v-if="channel_id">
              <td-c>
                <template v-if="list.channel">
                  <span>{{list.channel.name}}</span>
                </template>
              </td-c>
            </template>
            <template v-if="registration_date"><td-c>{{list.registration_date}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'tutor_channel',
  pageNames: 'tutor_channels'
}

let _ = window._
export default {
  props: {
    tutor: Object
  },
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',
      searchType: '',

      id: false,
      tutor_id: false,
      channel_id: true,
      registration_date: true,
      created_at: false,

      // search params
      searchQuery: {
        id: '',
        tutor_id: '',
        channel_id: '',
        registration_date: '',
        created_at: ''
      },

      notSearchQuery: {
        id: '',
        tutor_id: '',
        channel_id: '',
        registration_date: '',
        created_at: ''
      },

      watchSearch: {
        channel_id: '',
        not_channel_id: ''
      },

      // post params
      tutor_channel: {
        channel_id: '',
        registration_date: ''
      },

      watch: {
        channel_id: ''
      },

      // patch params
      tutor_channelPatch: {
        channel_id: '',
        registration_date: ''
      },
      watchPatch: {
        channel_id: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },

    channels () {
      return this.$store.getters.channels
    },

    office_channels () {
      return this.$store.getters.office_channels
    },

    orderedOffice_channels () {
      return _.orderBy(this.office_channels, 'id')
    },

    filteredOffice_channels () {
      let self = this
      return self.orderedOffice_channels.filter(office_channel => {
        return office_channel.state === 1 && office_channel.office_id === self.user.office_id
      })
    },

    mapOffice_channels () {
      return this.filteredOffice_channels.map(office_channel => {
        office_channel.mapChannel_id = this.calcArry(office_channel.channel_id, 'channels')
        return office_channel
      })
    },

    orderedTutor_channels () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.tutor.tutor_channels, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.tutor.tutor_channels, this.desc).reverse()
      }
    },

    FilteredTutor_channels () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.searchQuery) // ["id", "tutor_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.searchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.tutor.tutor_channels // 全部返す
      }
      // isSearch じゃなければfilterする
      return self.tutor.tutor_channels.filter((el) => {
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.searchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return flg
      })
    },

    notFilteredTutor_channels () {
      var self = this // function の中でthisが使えないのでselfに置き換え
      var key = Object.keys(this.notSearchQuery) // ["id", "tutor_id",・・・]
      // console.log(key)
      let isSearch = key.every((e) => {
        if (!self.notSearchQuery[e]) {
          return true // default (全てfalseの場合)
        } else {
          return false // search 何か入力されてたらsearch
        }
      })
      // console.log(isSearch)
      if (isSearch) {
        return self.FilteredTutor_channels // 全部返す FilteredContractsを返す
      }
      // isSearch じゃなければfilterする
      return self.FilteredTutor_channels.filter((el) => { // FilteredContractsにfilterをかける
        let re = [] // 正規表現の配列
        for (var i = 0; i < key.length; i++) {
          re.push(new RegExp(self.notSearchQuery[key[i]]))
        }
        // console.log(re)

        let els = [] // 正規表現と入力された値をtest関数で比べて返ってきたtrue,falseの配列
        for (var t = 0; t < key.length; t++) {
          let column = key[t]
          let input = el[[column]]
          els.push(re[t].test(input))
        }
        // console.log(els)

        let flg = els.every((el) => {
          if (el) {
            return true
          } else {
            return false
          }
        })
        // console.log(flg)
        return !flg // 反転
      })
    }
  },
  watch: {
    'watch.channel_id': function (now, old) {
      if (now) {
        this.tutor_channel.channel_id = now.channel_id
      } else {
        this.tutor_channel.channel_id = ''
      }
    },

    'watchSearch.channel_id': function (now, old) {
      if (now) {
        this.searchQuery.channel_id = now.channel_id
      } else {
        this.searchQuery.channel_id = '' // 一度選択してdeleteで解除できなかったからこれ書いといたほうがいい
      }
    },

    'watchSearch.not_channel_id': function (now, old) {
      if (now) {
        this.notSearchQuery.channel_id = now.channel_id
      } else {
        this.notSearchQuery.channel_id = ''
      }
    },

    'watchPatch.channel_id': function (now, old) {
      if (now) {
        this.tutor_channelPatch.channel_id = now.channel_id
      } else {
        this.tutor_channelPatch.channel_id = ''
      }
    }
  },
  methods: {
    calcArry (val, text) {
      // console.log(this[text])
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.tutor_id = false
      this.channel_id = false
      this.registration_date = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.tutor_id = true
      this.channel_id = true
      this.registration_date = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    // searchTable (e) {
    //   this.$store.dispatch('SEARCH', {
    //     this: this,
    //     e: e,
    //     obj: obj
    //   })
    // },

    editTutor_channel (list) {
      this.edit_id.edit_id = list.id

      // console.log(list.channel.name)
      // console.log(list.channel_id)
      let a = list.channel.name
      let b = list.channel_id
      let obj = {}
      obj.mapChannel_id = a
      obj.channel_id = b
      console.log(obj)
      this.watchPatch.channel_id = obj
    },

    postTutor_channel () {
      this.$store.dispatch('postTutor_channel', {
        this: this,
        tutor_channel: this.tutor_channel,
        watch: this.watch
      })
    },

    deleteTutor_channel (list) {
      this.$store.dispatch('deleteTutor_channel', {
        this: this,
        list: list
      })
    },

    cancelTutor_channel (list) {
      this.$store.dispatch('cancelTutor_channel', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchTutor_channel (list) {
      this.$store.dispatch('patchTutor_channel', {
        this: this,
        list: list,
        tutor_channel: this.tutor_channelPatch,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.index-box {
  height: calc(100vh - 280px);
  overflow: scroll;
  margin-top: 10px;
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
}
.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.TutorMedium {
  .index-box {
    .multiselect {
      min-height: 23px;
      min-width: 100px;
    }
    .multiselect__tags {
      border: solid 1px #ccc;
      min-height: 23px;
      padding: 0px 23px 0 2px;
      border-radius: 0;
      border: none;
    }
    .multiselect__input {
      margin-bottom: 0;
      height: 23px;
    }
    .multiselect__select {
      height: 23px;
      width: 26px;
      top: 2px;
      padding: 0;
    }
  }
}
</style>

<style lang="scss">
.mediumForm {
  font-size: .85rem;
  display: flex;
  align-items: center;
  .mediumPost {
    display: flex;
  }
  .mediumForm-input {
    height: 36px;
    width: 85px;
    padding-left: 5px;
    border-radius: 0;
    border: solid 1px #ccc;
  }

  .multiselect {
    min-height: 36px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 36px;
    width: 200px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 36px;
  }
  .multiselect__select {
    height: 36px;
  }
  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
  .multiselect__placeholder {
    padding: 11px 3px;
    margin: 0;
    font-size: .85rem;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// TutorMedium.vue?c2c15a1c